const STAY_COLORS = [
  "hsl(var(--stay-1))",
  "hsl(var(--stay-2))",
  "hsl(var(--stay-3))",
  "hsl(var(--stay-4))",
  "hsl(var(--stay-5))",
];

export function getStayColor(stayIndex: number): string {
  const idx = Math.max(0, stayIndex - 1) % STAY_COLORS.length;
  return STAY_COLORS[idx];
}

export function getStayCssVar(stayIndex: number): string {
  const idx = ((Math.max(0, stayIndex - 1) % 5) + 1);
  return `var(--stay-${idx})`;
}

export { STAY_COLORS };
